import { CloseIconsForModalWithDataTestId } from '@app/components/CloseIconsForModalWithDataTestId/CloseIconsForModalWithDataTestId';

export { CloseIconsForModalWithDataTestId };
